import { type JSX, memo } from 'react';
import type { XY } from 'src/lib/player/store';
import tinycolor from 'tinycolor2';
import type { Bounds } from '../InfoSheet/SVGChart';
import {
  getInterpolatedElevation,
  getInterpolatedY,
  projectX,
  type ViewRange,
} from './heightChartUtils';

export const HeightChartPolyline = memo(function HeightChartPolyline({
  filteredTrack,
  viewRange,
  bounds,
  lineColor,
}: {
  filteredTrack: Array<XY>;
  viewRange: ViewRange;
  bounds: Bounds;
  lineColor: string;
}): JSX.Element {
  const { minX, maxX, minY, maxY } = viewRange;
  const visiblePoints = filteredTrack.filter((p) => p.x >= minX && p.x <= maxX);
  const leftEdgeY = getInterpolatedElevation(filteredTrack, minX);
  const rightEdgeY = getInterpolatedElevation(filteredTrack, maxX);
  const clipped = [
    { x: minX, y: minY },
    { x: minX, y: Number.isNaN(leftEdgeY) ? minY : leftEdgeY },
    ...visiblePoints,
    { x: maxX, y: Number.isNaN(rightEdgeY) ? minY : rightEdgeY },
    { x: maxX, y: minY },
  ];
  return (
    <polygon
      points={clipped
        .map(
          (point) =>
            `${projectX(point.x, viewRange, bounds)} ${getInterpolatedY(
              point.y,
              minY,
              maxY,
              bounds,
            )}`,
        )
        .join(' ')}
      fill={`${tinycolor(lineColor).setAlpha(0.6).toRgbString()}`}
      stroke={lineColor}
      strokeWidth={1}
    />
  );
});
